// extracted by mini-css-extract-plugin
export var indeterminate = "_1j-5";
export var md = "_1j-4";
export var semantic = "_1j-6";
export var sm = "_1j-3";
export var text = "_1j-7";
export var toggleInput = "_1j-0";
export var toggleSwitch = "_1j-1";
export var xs = "_1j-2";